<template>
  <div>
    {{info}}
    <van-field
      v-model="info.自我评价"
      label="自我评价"
      placeholder="自我评价"
      type="textarea"
      rows="4"
      :rules="[{ required: true, message: '自我评价不能为空' }]"
    />
    <div style="margin: 16px">
      <van-row>
        <van-col span="8"
          ><van-button round block @click.prevent="$emit('handlerStep', -1)"
            >上一步</van-button
          >
        </van-col>
        <van-col span="8">
          
        </van-col>
        <van-col span="8">
          <van-button round block @click.prevent="$emit('handlerStep', 1)"
            >提交</van-button
          >
        </van-col>
      </van-row>
        </div>
  </div>
  
</template>
<script>
export default {
  name: "baseinfo",
  props: ["info"],
  data() {
    return {
        
    };
  },
  methods: {
    
  },
};
</script>
<style scoped>
.prop{
  font-size: 12px;
  
 background-color: chocolate;
  color: cadetblue;
}
</style>
